import uploadOptionsModule from "./goodsOptionsModule";
import packageOptionsModule from "./packageOptionsModule";

const headers = new Headers({
  "Content-Type": "application/json",
});

function recursiveSearch(rid, group) {
  if (group.rid == rid) return group;
  for (const child of group.child_groups) {
    let found = recursiveSearch(rid, child);
    if (found) return found;
  }
  return null;
}

export default {
  state: {
    goodsACats: null,
    goodsCats: null,
    goodsGroups: null,
    shUnitsGroups: null,
    packageGroups: null,
  },
  mutations: {
    updateSHData(
      state,
      { goodsACats, goodsCats, goodsGroups, shUnitsGroups, packageGroups }
    ) {
      state.goodsACats = goodsACats;
      state.goodsCats = goodsCats;
      state.goodsGroups = goodsGroups;
      state.shUnitsGroups = shUnitsGroups;
      state.packageGroups = packageGroups;
    },
    updateSHUnitsGroups(state, val) {
      state.shUnitsGroups = val;
    },
    addUnitToGroup(state, { group_rid, unit }) {
      const group = state.shUnitsGroups.find((g) => g.rid == group_rid);
      if (group != undefined) {
        group.units.push(unit);
      }
    },
    addGroup(state, { group, parentRid }) {
      let found = null;
      for (const groupNode of state.goodsGroups) {
        found = recursiveSearch(parentRid, groupNode);
        if (found != null) {
          found.child_groups.push(group);
          return;
        }
      }
    },
    addPackGroup(state, { group, parentRid }) {
      let found = null;
      for (const groupNode of state.packageGroups) {
        found = recursiveSearch(parentRid, groupNode);
        if (found != null) {
          found.child_groups.push(group);
          return;
        }
      }
    },
  },
  getters: {
    aCategories(state) {
      return state.goodsACats;
    },
    gCategories(state) {
      return state.goodsCats;
    },
    gGroups(state) {
      return state.goodsGroups;
    },
    SHDataOk(state) {
      return (
        state.goodsACats != null &&
        state.goodsCats != null &&
        state.goodsGroups != null &&
        state.packageGroups != null
      );
    },
    SHUnits(state) {
      let units = [];
      if (state.shUnitsGroups != null) {
        for (const unitG in state.shUnitsGroups) {
          for (const unit in state.shUnitsGroups[unitG].units) {
            units.push(
              Object.assign({}, state.shUnitsGroups[unitG].units[unit])
            );
          }
        }
      }
      return units;
    },
    SHUnitsGroups(state) {
      return state.shUnitsGroups;
    },
    packageGroups(state) {
      return state.packageGroups;
    },
  },
  actions: {
    clearSHData(context) {
      context.commit("updateSHData", {
        goodsACats: null,
        goodsCats: null,
        goodsGroups: null,
        shUnitsGroups: null,
        packageGroups: null,
      });
    },
    async getSHData(context) {
      const obj = Object.assign({}, context.getters.selected, {
        nested: true,
      });
      const init = {
        method: "POST",
        body: JSON.stringify(obj),
        headers: headers,
      };
      let goodsACats = null;
      let goodsCats = null;
      let goodsGroups = null;
      let shUnitsGroups = null;
      let packageGroups = null;
      try {
        let res1 = await fetch(
          new Request(
            `${context.getters.url}/api/v1/sh/categories/accounting`,
            init
          )
        );
        let res2 = await fetch(
          new Request(`${context.getters.url}/api/v1/sh/categories/goods`, init)
        );
        let res3 = await fetch(
          new Request(`${context.getters.url}/api/v1/sh/goods/groups`),
          init
        );
        let res4 = await fetch(
          new Request(`${context.getters.url}/api/v1/sh/units/groups`),
          init
        );
        let res5 = await fetch(
          new Request(`${context.getters.url}/api/v1/sh/packages/groups`),
          init
        );
        if (
          res1.status == 200 &&
          res2.status == 200 &&
          res3.status == 200 &&
          res4.status == 200 &&
          res5.status == 200
        ) {
          goodsACats = await res1.json();
          goodsCats = await res2.json();
          goodsGroups = await res3.json();
          shUnitsGroups = await res4.json();
          packageGroups = await res5.json();
        } else {
          let msg = "";
          if (res1.status != 200) {
            msg = msg + "Ошибка получения бух. категорий товаров. ";
          } else if (res2.status != 200) {
            msg = msg + "Ошибка получения категорий товаров. ";
          } else if (res3.status != 200) {
            msg = msg + "Ошибка получения групп товаров. ";
          } else if (res4.status != 200) {
            msg = msg + "Ошибка получения ед. измерений. ";
          } else if (res5.status != 200) {
            msg = msg + "Ошибка получения групп комплектов. ";
          }
          throw new Error(msg);
        }
        context.commit("updateMessage", {
          title: `Статус подключения`,
          text: "Успешное подключение",
          isError: false,
        });
      } catch (error) {
        context.commit("updateMessage", {
          title: `Ошибка загрузки данных из SH`,
          text: `Ошибка: ${error.message}`,
          isError: true,
        });
      } finally {
        context.commit("updateSHData", {
          goodsACats,
          goodsCats,
          goodsGroups,
          shUnitsGroups,
          packageGroups,
        });
      }
    },
    async createUnit(context, { name, group_rid, coeff }) {
      let group = { name: "create", rid: group_rid, units: null };
      group["units"] = [{ name, coeff, rid: null }];
      let body = Object.assign({}, context.getters.selected, {
        unit_groups: [group],
        nested: false,
      });
      try {
        let res = await fetch(`${context.getters.url}/api/v1/sh/units/create`, {
          method: "POST",
          body: JSON.stringify(body),
          headers: headers,
        });
        if (res.status == 200) {
          let json = await res.json();
          let unit = json[0]["units"][0];
          context.commit("addUnitToGroup", { group_rid, unit });
          return unit;
        } else {
          let message = (await res.text());
          throw new Error(message);
        }
      } catch (error) {
        context.commit("updateMessage", {
          title: `Ошибка создания ед. измерения`,
          text: `Ошибка: ${error.message}`,
          isError: true,
        });
        return null;
      }
    },
    async createGroup(context, { parent, name }) {
      const obj = Object.assign({}, context.getters.selected);
      obj.parentRid = parent.rid;
      obj.newGroup = {
        name,
        rid: null,
        child_groups: [],
        goods: [],
        root: false,
      };
      try {
        let res = await fetch(`${context.getters.url}/api/v1/sh/goods/group`, {
          method: "POST",
          body: JSON.stringify(obj),
          headers: headers,
        });
        if (res.status == 200) {
          let group = await res.json();
          context.commit("addGroup", { group, parentRid: parent.rid });
          return group.rid;
        } else {
          throw new Error("Не удалось создать группу");
        }
      } catch (error) {
        context.commit("updateMessage", {
          title: `Ошибка создания группы`,
          text: `Ошибка: ${error.message}`,
          isError: true,
        });
      }
    },
    async createPackageGroup(context, { parent, name }) {
      const obj = Object.assign({}, context.getters.selected);
      obj.parentRid = parent.rid;
      obj.newGroup = {
        name,
      };
      try {
        let res = await fetch(
          `${context.getters.url}/api/v1/sh/packages/group`,
          {
            method: "POST",
            body: JSON.stringify(obj),
            headers: headers,
          }
        );
        if (res.status == 200) {
          let group = await res.json();
          context.commit("addPackGroup", { group, parentRid: parent.rid });
          return group.rid;
        } else {
          throw new Error("Не удалось создать группу комплектов");
        }
      } catch (error) {
        context.commit("updateMessage", {
          title: `Ошибка создания группы комплектов`,
          text: `Ошибка: ${error.message}`,
          isError: true,
        });
      }
    },
  },
  modules: {
    uploadOptionsModule,
    packageOptionsModule,
  },
};
